import React from 'react'

export default {
    values: {
        'Add a channel': 'Adicione um canal',
        'Loading..': 'Carregando..',
        'Loading channels..': 'Carregando canais..',
        'Select a data first': 'Selecione um dado antes',
        'Select an asset': 'Selecione um ativo',
        'DATA OPTIONS': 'DADOS',
        CHANNELS: 'CANAIS',
        CHART: 'GRÁFICO',
        STYLE: 'ESTILO',
        'Temporal channels chart': 'Gráfico temporal de canais',
        'Value channels chart': 'Gráfico de valores de canais',
        'Select the data channels using user interface instead of writing pipes code':
            'Selecione os canais de dados usando a interface ao invés de escrever código pipes',
        'Error while fetching asset list': 'Erro ao buscar lista de ativos',
        'Error while fetching canais list': 'Erro ao buscar lista de canais',
        'Error while fetching default channels': 'Erro ao buscar canais padrão',
        'NO SELECTED OR VALID DATA': 'DADOS NÃO SELECIONADOS OU INVÁLIDOS',
        "The asset wasn't found.": 'O recurso não foi encontrado.',
        'TO PREVIEW A CHART': 'PARA VISUALIZAR UM GRÁFICO',
        'SELECT A CHANNEL': 'SELECIONE UM CANAL',
        'SELECT A RIG': 'SELECIONE UMA SONDA',
        'Background Color': 'Cor de fundo',
        'pronoun-asset': 'um ativo',
        asset: 'ativo',
        Select: 'Selecione',
        'blank-state-NO': 'NÃO HÁ ',
        'blank-state-AVAILABLE': ' DISPONÍVEL',
        'NO CHANNEL AVAILABLE': 'NÃO HÁ CANAL DISPONÍVEL',
        Channel: 'Canal',
        'Select a channel': 'Selecione um canal',
        'VALUE OPTIONS': 'OPÇÕES DO VALOR',
        'Value Font Color': 'Cor de fonte do valor',
        'Value Font Style': 'Estilo de fonte do valor',
        'UNIT OPTIONS': 'OPÇÕES DA UNIDADE',
        'Unit Font Color': 'Cor de fonte da unidade',
        'Unit proportion': 'Proporção da unidade',
        'Unit Font Style': 'Estilo de fonte da unidade',
        Position: 'Posição',
        Resizing: 'Redimensionamento',
        'Adjust to fit': 'Ajuste para caber',
        'Fit to max height': 'Ajuste à altura máxima',
        'Max height': 'Altura máxima',
        'Dashboard Theme Color': 'Cor de Tema do Dashboard',
        'Custom Color': 'Cor Personalizada',
        'Default Channel Color': 'Cor Padrão do Canal',
        'Received at': 'Recebido em',
        'Block asset selection on view mode': 'Bloquear seleção de ativo no modo de visualização',
        'Asset selection on view mode': 'Seleção de ativo no modo de visualização',
        axes: 'eixos',
        'Line width': 'Espessura',
        'Line style': 'Estilo da linha',
        'Not available for this type of channel': 'Não disponível para este tipo de canal',
        'Auto analyzer tool': 'Ferramenta de auto análise',
        Help: 'Ajuda',
        'Select the channel you want to analyse. Then, you can click OK and use the drag and drop tool':
            'Selecione o canal a ser analisado. Então clique em OK e use a ferramenta de arrastar e soltar',
        'to choose a time span of your interest.': 'para selecionar o intervalo de tempo desejado.',
        'Ok, got it': 'Ok, entendido',
        'Choose a channel to analyse': 'Selecione o canal a ser analisado',
        'How would you like to interact with the chart': 'Como gostaria de interagir com o gráfico',
        'Drag and drop': 'Arrastar e soltar',
        'Automatic analysis': 'Análise automática',
        Average: 'Média',
        'Standard deviation': 'Desvio padrão',
        Maximum: 'Máximo',
        Minimum: 'Mínimo',
        'Would you like to comment and save these results? Both are optional.':
            'Gostaria de comentar e salvar os resultados? Ambos são opcionais.',
        'Linear Regression': 'Regressão linear',
        'Original Curve': 'Curva original',
        'Would you like to add or edit a comment': 'Gostaria de adicionar ou editar um comentário',
        'Create note': 'Criar nota',
        'discard the results': 'descartar os resultados',
        'Auto analysis': 'Análise automática',
        'Channel analysis': 'Análise do canal',
        'General analysis': 'Análise geral',
        Derivatives: 'Derivadas',
        'First Derivative': 'Derivada primeira',
        'Second Derivative': 'Derivada segunda',
        Slope: 'C. angular',
        Intercept: 'C. linear',
        Correlation: 'Correlação',
        'First derivative': 'Derivada primeira',
        'Second derivative': 'Derivada segunda',
        average: 'média',
        'Linear regression': 'Regressão linear',
        'linear regression': 'regressão linear',
        'is varying, in average, at the rate of': 'esta variando, em média, a taxa de',
        'appears to have no, average, variation over time': 'parece não ter variação, em média, ao decorrer do tempo',
        'is varying velocity, in average, at the rate of': 'esta variando velocidade, em média, a taxa de',
        'appears to have no, average, velocity variation over time':
            'parece não ter variação de velocidade, em média, ao decorrer do tempo',
        'Use the same scale for channels with the same measurement unit':
            'Utilizar a mesma escala para canais com a mesma unidade de medida',
        'Use filter to select asset': 'Utilizar filtro para selecionar ativo',
        'Test asset filter': 'Teste de filtro',
        'Numeric Formatting': 'Formatação Numérica',
        'Format (based on language)': 'Formatar (baseado no idioma)',
        'Precision (fraction digits)': 'Precisão (dígitos fracionários)',
        'config-converted-value': 'Este valor é derivado da conversão de ',
        'invalid-logarithmic-value': 'Não é possível utilizar valores negativos ou zero com a escala logarítmica',
        'Automatic color': 'Cor automática',
        'Custom color': 'Cor customizada',
        'Text Size': 'Tamanho da fonte',
        Default: 'Padrão',
        'Font style': 'Estilo da fonte',
        'Symbol stroke': 'Traço do símbolo',
        'Symbol type': 'Símbolo',
        'Symbol size': 'Tamanho',
        Medium: 'Médio',
        'Fill Style': 'Estilo de preenchimento',
        'Gradient on X axis': 'Gradiente no eixo X',
        'Gradient on Y axis': 'Gradiente no eixo Y',
        'Choose a gradient color': 'Escolha uma cor de gradiente',
        'Invert colors': 'Cores invertidas',
        'Single Color': 'Gradiente de uma cor',
        'Two Colors': 'Gradiente de duas cores',
        'Three Colors': 'Gradiente de três cores',
        Sequential: 'Sequencial',
        Diverging: 'Divergente',
        Solid: 'Sólida'
    }
}
